import React, { useCallback } from "react";
import { t } from "../../../../utils/i18n";
import { validatePaymentForm } from "../Helper";

const useFormValidation = (formData, integration) => {
  const validateForm = useCallback(() => {
    const newErrors = {};

    if (
      formData.amount === undefined ||
      formData.amount === null ||
      String(formData.amount).trim() === ""
    ) {
      newErrors.amount = t("store_integrations.widget.amount_required");
    } else if (
      isNaN(parseFloat(formData.amount)) ||
      parseFloat(formData.amount) < 0
    ) {
      newErrors.amount = t("store_integrations.widget.valid_amount");
    }

    if (!formData.currency || formData.currency.trim() === "") {
      newErrors.currency = t("store_integrations.widget.currency_required");
    }

    if (!formData.product_name || formData.product_name.trim() === "") {
      newErrors.product_name = t("store_integrations.widget.product_name_required");
    }

    if (!formData.description || formData.description.trim() === "") {
      newErrors.description = t("store_integrations.widget.description_required");
    }

    // Only validate GHL API key for new widgets, never for editing
    if (!integration || !integration.id) {
      if (
        formData.gohighlevel_enabled &&
        (!formData.gohighlevel_api_key ||
          formData.gohighlevel_api_key.trim() === "")
      ) {
        newErrors.gohighlevel_api_key =
          t("store_integrations.widget.ghl_key_required_new");
      }
    }

    const additionalErrors = validatePaymentForm(formData);

    return { ...newErrors, ...additionalErrors };
  }, [formData, integration]);

  const validateField = useCallback(
    (fieldName, fieldValue) => {
      const fieldValidations = {
        amount: () => {
          if (
            fieldValue === undefined ||
            fieldValue === null ||
            String(fieldValue).trim() === ""
          )
            return t("store_integrations.widget.amount_required");
          if (isNaN(parseFloat(fieldValue)) || parseFloat(fieldValue) < 0)
            return t("store_integrations.widget.valid_amount");
          return null;
        },
        currency: () =>
          !fieldValue || fieldValue.trim() === ""
            ? t("store_integrations.widget.currency_required")
            : null,
        product_name: () =>
          !fieldValue || fieldValue.trim() === ""
            ? t("store_integrations.widget.product_name_required")
            : null,
        description: () =>
          !fieldValue || fieldValue.trim() === ""
            ? t("store_integrations.widget.description_required")
            : null,
        gohighlevel_api_key: () => {
          if (
            formData.gohighlevel_enabled &&
            (!fieldValue || fieldValue.trim() === "")
          ) {
            if (!integration || !integration.id) {
              return t("store_integrations.widget.ghl_key_required_new");
            }
          }
          return null;
        },
      };

      if (fieldValidations[fieldName]) {
        return fieldValidations[fieldName]();
      }
      return null;
    },
    [formData, integration],
  );

  return { validateForm, validateField };
};

export default useFormValidation;
